module.exports = __webpack_public_path__ + "media/images/elements/Elemntas_5-05860ae1ae43117eae78c0874ae7a292.svg";